import isElem from '../../scripts/util/isElement';
import bindEvent from '../../scripts/util/bindEvent';
import $ from 'jquery';

const selectors = {
	btn: '.js-unsubscribe-form__subscribe-btn',
	reSubInner: '.js-unsubscribe-form__inner-resubscribe',
	successInner: '.js-unsubscribe-form__inner-success'
};

const reSubscribe = e => {
	e.preventDefault();

	const email = $(selectors.btn).attr('data-email');
	const key = $(selectors.btn).attr('data-key');

	$.getJSON('subscribe?email=' + email + '&key=' + key,
		function (data) {
			data = $.parseJSON(data.toString());
			if (data.status === 'success') {
				$(selectors.reSubInner).hide();
				$(selectors.successInner).show();
			}
		});
};

const render = () => {
	if (isElem(selectors.btn)) {
		bindEvent(selectors.btn, 'click', reSubscribe);
	}
};

export default render;
